module.exports = __webpack_public_path__ + "static/media/Facebook.7a687740.svg";